<script>
  export let svgFile; // t.ex. "2026-02-06_10-30.svg"


    const BASE = "./local_assets/os2026/event-svgs/";


    export function replaceAao(str = "") {

      str = str.replace("å", "a");

      return str;
    }
    


</script>

{#if svgFile}
<div class="aborderwrapper"><div class="aborder top-double-border"></div></div>
  <div class="event-expand-svg ">
    <img
      src={`./local_assets/os2026/event-svgs/${replaceAao(svgFile)}`}
      alt=""
      loading="lazy"
      on:error={(e) => (e.currentTarget.style.display = "none")}
    />
  </div>
{/if}


<style global type="text/scss" lang="scss">

.event-expand-svg {
  margin-top: 0rem;
  padding-top: 0rem;
  border-top: 0px solid var(--color-border);
  max-width: 450px;
}

.event-expand-svg img {
  width: 100%;
  height: auto;
  display: block;
}
.double-border {
  border: 2px solid transparent; /* själva tjockleken */
  background:
    linear-gradient(#fff, #fff) padding-box,                 /* fyllning (byt #fff om du vill) */
    linear-gradient(to bottom, #c7bb48 0 50%, #e0d24e 50% 100%) border-box; /* 2 färger */
  background-clip: padding-box, border-box;
}
.aborderwrapper {
  position: relative;
  width: 100%;
  height: 2px;
  background-color: transparent;
  padding-left: 1rem;
  box-sizing: border-box;
}
.aborder {
  position: relative;
  width: 100%;
  height: 2px;
  opacity:1;
  background-color: transparent;
  box-sizing: border-box;
}

.top-double-border {
  position: relative;
}

.top-double-border::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(
    to bottom,
    #e6d850 50%,
    #c7bb48 50% 100%
  );
}
</style>